import {
  ADD_COUNTDOWN_CLOCK_SUCCESS,
  DELETE_COUNTDOWN_CLOCK_SUCCESS,
  GET_COUNTDOWN_CLOCK,
  GET_COUNTDOWN_CLOCK_LIST,
  GET_COUNTDOWN_CLOCK_LIST_SUCCESS,
  GET_COUNTDOWN_CLOCK_SUCCESS,
  HIDE_DELETE_COUNTDOWN_CLOCK_MODAL,
  OPEN_DELETE_COUNTDOWN_CLOCK_MODAL,
  RESET_COUNTDOWN_CLOCK,
  RESET_COUNTDOWN_CLOCK_LIST,
  UPDATE_COUNTDOWN_CLOCK_ORDER_SUCCESS,
  UPDATE_COUNTDOWN_CLOCK_STATUS_SUCCESS,
  UPDATE_COUNTDOWN_CLOCK_SUCCESS,
} from "./actionTypes"

const INIT_STATE = {
  countdownClockList: [],
  loading: false,
  listLoading: false,
  countdownClock: null,
  isDeleteCountdownClockModalOpen: false,
  destroyed: false,
  listDestroyed: false,
}

const CountdownClock = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_COUNTDOWN_CLOCK:
      return {
        ...state,
        loading: true,
        destroyed: false,
      }
    case GET_COUNTDOWN_CLOCK_SUCCESS:
      return {
        ...state,
        countdownClock: action.payload,
        loading: false,
      }
    case RESET_COUNTDOWN_CLOCK:
      return {
        ...state,
        countdownClock: null,
        destroyed: true,
        loading: false,
      }
    case ADD_COUNTDOWN_CLOCK_SUCCESS:
      if (action.payload.menu_feature === 1) {
        return { ...state, countdownClock: action.payload }
      } else {
        return {
          ...state,
          countdownClockList: [...state.countdownClockList, action.payload],
        }
      }
    case UPDATE_COUNTDOWN_CLOCK_SUCCESS:
      if (action.payload.length === 0) {
        return state
      } else {
        return {
          ...state,
          countdownClockList: action.payload,
        }
      }
    case OPEN_DELETE_COUNTDOWN_CLOCK_MODAL:
      return {
        ...state,
        isDeleteCountdownClockModalOpen: true,
      }
    case HIDE_DELETE_COUNTDOWN_CLOCK_MODAL:
      return {
        ...state,
        isDeleteCountdownClockModalOpen: false,
      }
    case GET_COUNTDOWN_CLOCK_LIST:
      return {
        ...state,
        listLoading: true,
        listDestroyed: false,
      }
    case GET_COUNTDOWN_CLOCK_LIST_SUCCESS:
      return {
        ...state,
        countdownClockList: action.payload,
        listLoading: false,
      }
    case DELETE_COUNTDOWN_CLOCK_SUCCESS:
    case UPDATE_COUNTDOWN_CLOCK_ORDER_SUCCESS:
    case UPDATE_COUNTDOWN_CLOCK_STATUS_SUCCESS:
      return {
        ...state,
        countdownClockList: action.payload,
      }
    case RESET_COUNTDOWN_CLOCK_LIST:
      return {
        ...state,
        countdownClockList: [],
        listDestroyed: true,
        listLoading: false,
      }
    default:
      return state
  }
}

export default CountdownClock
